module.exports = __webpack_public_path__ + "img/WechatIMG77.6b2688fd.jpg";